// extracted by mini-css-extract-plugin
export default {"title":"info_title__wfjbl","img":"info_img__NES1z","subTitle":"info_subTitle__ob868","description":"info_description__glwz4","text":"info_text__P0GI5"};